
const locales_en = {
    text: '文本',
    defaultQuickReplies_en :[
        {
            icon: 'message',
            name: 'Human service',
            code: 'human'
        },
        {
            icon: 'search',
            name: 'Report verification',
            code: 'report'
        },
        {
            icon: 'tel',
            name: 'Contact us',
            code: 'contact'
        },
        {
            icon: 'info-circle',
            name: 'Recruitment information',
            code: 'recruit'
        },
        {
            icon: 'alarm',
            name: 'Complaints and suggestions',
            code: 'complaints'
        }
    ],
    humanReplyMessage: "Hi!How can I help you?<a href='https://bwt.zoosnet.net/LR/Chatpre.aspx?id=BWT60790040&lng=en&p=AI'>[Human service link]</a>",
    nohumanReplyMessage: `This is a non-working time period, you can <a href = 'https://www.ctimall.com/ctivue/OfferConsulting'> leave us a message</a> and we will reply to you ASAP. Thanks!`,
    reportReplayMessage: `Test report self-service inquiry method:\n1. Report inquiry address:\n1、Report query address：<a href='https://mycti.cti-cert.com/'>https://mycti.cti-cert.com/</a> Enter the report number → enter the report verification code (Number in the lower right corner of the first page of the report) → verification code → report inquiry → preview the report and download the report.
                            \n<img style='width:100%;height:auto;' src='https://mycti.cti-cert.com/Images/Tips/AI-Tips.jpg'>
                            \n2、Verified by QR code in WeChat scan report.<span style="color:red">Please note! After inquiring, compare the report in your hand with our system report to see if it is consistent. If the content is consistent, it is true and effective.</span>
                            \n3、Send the complete electronic version of the report and your specific needs or questions to our mailbox by email：info@cti-cert.com，We will ask our colleagues in the reporting team to help inquire and reply to you by email.
                            \n4、Report numbers starting with "EED31" and "EED32" check the authenticity of the report URL (the electronic version of the report is encrypted)：<a href='http://yz.cnca.cn/ver-ep/ve/v/pdfveri.jsp'>http://yz.cnca.cn/ver-ep/ve/v/pdfveri.jsp</a>`,
    contactReplyMessage: `CTI Mall Online Customer Service Hotline\n☎️：400-6788-333\n📮：info@cti-cert.com\nIf there is no response, please <a href = 'https://www.ctimall.com/ctivue/OfferConsulting' >leave us a message</a> and we will reply to you ASAP. Thanks.`,
    recruitReplyMessage: `Welcome to join us!\nYou can learn about the positions we are recruiting in the following ways:\n🚀Official website：<a href='https://app.mokahr.com/social-recruitment/cti/145979#/'>https://app.mokahr.com/social-recruitment/cti/145979#/</a>`,
    complaintsReplyMessage: `If you have any suggestions for us or any questions during the service process, you can contact us in the following ways to handle your request in a timely and accurate manner.\nTel：0755-33681700\nEmail：complaint@cti-cert.com\n（Please include the following information in the email: the reason for the suggestion/dissatisfaction, the report number, the information of the CTI docking staff, your phone number and email address）`,

};

export default locales_en
